import React, {useEffect, useState} from 'react';
import {Badge, Button, Calendar, Space, Spin} from "antd";
import  './index.css';
import moment from "moment/moment";

function CalendarDeal({callback,schedulListData}) {
  const [isLoading, setIsLoading] = useState(true);

  const [calendarDataList,setCalendarData] = useState({});

  const getListData = (value) => {
    let listData;
    switch (value.date()) {
      case 8:
        listData = [
          {
            type: 'warning',
            content: '审核员A',
          },
          {
            type: 'success',
            content: '审核员B',
          },
        ];
        break;
      case 10:
        listData = [
          {
            type: 'warning',
            content: '审核员A',
          },
          {
            type: 'success',
            content: '审核员B',
          },
          {
            type: 'error',
            content: '审核员A',
          },
        ];
        break;
      case 15:
        listData = [
          {
            type: 'warning',

            content: '审核员A',
          },
          {
            type: 'success',
            content: '审核员B',
          },
          {
            type: 'error',
            content: '审核员B',
          },
          {
            type: 'error',
            content: '审核员A',
          },
          {
            type: 'error',
            content: '审核员A',
          },
          {
            type: 'error',
            content: '审核员A',
          },
        ];
        break;
      default:
    }
    return listData || [];
  };

  const getMonthData = (value) => {
    if (value.month() === 8) {
      return 1394;
    }
  };

  const monthCellRender = (value) => {
    const num = getMonthData(value);
    return num ? (
      <div className="notes-month">
        <section>{num}</section>
        <span>Backlog number</span>
      </div>
    ) : null;
  };
  /*
  日期
  人

   */

  const dateCellRender = (value) => {
    // const listData = getListData(value);
    return (
      <ul className="events">
        {value.map((item,index) => (
          <li key={index} title={item}>
            <Badge status={"success"} text={item.split('_')[0]+'-'+item.split('_')[1]} />
          </li>
        ))}
      </ul>
    );
  };

  const cellRender = (current, info) => {
    const date = current.format('YYYY-MM-DD');

    if (calendarDataList[date])
      return dateCellRender(calendarDataList[date].people);
    // if (info.type === 'month') return monthCellRender(current);


    return info.originNode;
  };

  const callbackHandler = () => {
    callback(true);
  }

  /*
    {

    }
   */

  const getDates = (startDateString, endDateString) => {

    const startDate = moment(startDateString);
    const endDate = moment(endDateString);
    let datesArray = [];
    while (!startDate.isAfter(endDate)) {
      datesArray.push(startDate.format('YYYY-MM-DD')); // 将每天的日期格式化为字符串并添加到数组中
      startDate.add(1, 'days'); // 逐天增加日期
    }

    return datesArray;
  }

  const onChange = (value) => {
    console.log(value.month()+1)
  }

  useEffect(()=>{
    /*
    分装数据
    1.获取开始时间到结束时间的所有日期
    2.封装数据格式
      {
      'yyyy-mm-dd':{
        'people':[
          a,b,c
        ]
      },
      'yyyy-mm-dd':{
        'people':[
          a,b,c
        ]
      },
      }
     */
    const calendarData = {};
    schedulListData.map(item=>{
      console.log(item)
      /*
      reviewStartDate : "2024-03-20 10点  星期3"
      reviewEndDate : "2024-03-29 15点  星期5"
      reviewLeader : "衡平"
      reviewMembers : "刘佳"
       */
      const startDate = item.reviewStartDate.substr(0,10)
      const endDate = item.reviewEndDate.substr(0,10)

      let dates = getDates(startDate,endDate);

      const info ='_'+item.projectSubtype +'_'+item.reviewType+'_'+item.enterpriseName;
      console.log(dates)
      dates.map(item2=>{
        if(calendarData[item2]){
          //当前日期是否包含该领导
          if(!calendarData[item2].people.includes(item.reviewLeader+info
          )){
            calendarData[item2].people.push(item.reviewLeader+info)
          }
          //当前日期是否包含该组员
          //根据,拆分合并的组员
          if(item.reviewMembers.includes(',')){
            item.reviewMembers.split(',').map(item3=>{
              if(!calendarData[item2].people.includes(item3+info)){
                calendarData[item2].people.push(item3+info)
              }
            })
          }else {
            if(!calendarData[item2].people.includes(item.reviewMembers+info)){
              calendarData[item2].people.push(item.reviewMembers+info)
            }
          }
        }else {
          if(item.reviewMembers.includes(',')){
            calendarData[item2]={
              'people':[item.reviewLeader+info]
            }
            item.reviewMembers.split(',').map(item4=>{
              calendarData[item2].people.push(item4+info)
            })
          }else {
            calendarData[item2]={
              'people':[item.reviewLeader+info,item.reviewMembers+info]
            }
          }


        }
      })
    })
    setCalendarData(calendarData);
    console.log(calendarData)

    setIsLoading(false)
  },[])

  return (

    <>
      {isLoading
        ?<Spin />:
        <Space direction={"vertical"} size={"small"}>
       <p>
           <h5>
             调度日历
           </h5>
       </p>
      <Calendar cellRender={cellRender} onChange={onChange} />
      <Button type={"default"} onClick={callbackHandler}>返回</Button>
      </Space>
      }
    </>

  );
}

export default CalendarDeal;
